import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EmptyStar, FullStar, HalfStar } from "../../svg/Index";

const SuccessMessage = (message) => {
  setTimeout(
    () =>
      toast.success(message, {
        position: "bottom-center",
        autoClose: 2000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: Zoom,
      }),
    10
  );
};

const getEstimatedDelivery = (orderDate) => {
  if (!orderDate) return "Processing";

  const date = new Date(orderDate); 

  const estimatedDate = new Date(date); 
  estimatedDate.setDate(date.getDate() + 5);

  return estimatedDate.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

const ErrorMessage = (message) => {
  toast.error(message, {
    position: "bottom-center",
    autoClose: 2000,
    theme: "dark",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Zoom,
  });
};


const removeAuth = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('accessToken');

}

const Apiloader = ({ type }) => {
  return (
    <div className="loading-wrapper">
      <div className="spinner"></div>
      <p className="text-white mt-3">Loading {type}...</p>
    </div>
  );
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export const DeleteModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <div className="modal-overlay-delete" style={{ zIndex: '99' }}>
      <div className="modal-content-delete">
        <p className="modal-message">{message}?</p>
        <div className="modal-buttons-delete d-flex justify-content-center">
          <button className="btn btn-secondary me-2 px-4" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-danger px-4" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export const renderStars = (rating) => {
  const ratingValue = parseFloat(rating) || 0;
  const stars = [];

  for (let i = 0; i < 5; i++) {
    const starValue = i + 1;

    if (ratingValue >= starValue) {
      stars.push(
        <img
          key={i}
          src="/image/star.svg"
          alt="filled star"
        />
      );
    } else if (ratingValue > starValue - 1) {
      const percentage = (ratingValue - (starValue - 1)) * 100;
      stars.push(
        <div key={i} style={{ position: 'relative', display: 'inline-block', width: '15px', height: '15px' }}>
          <img
            src="/image/unfilled-star.svg"
            alt="empty star"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: `${percentage}%`,
            overflow: 'hidden',
            height: '100%'
          }}>
            <img
              src="/image/star.svg"
              alt="filled star"
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        </div>
      );
    } else {
      stars.push(
        <img
          key={i}
          src="/image/unfilled-star.svg"
          alt="empty star"
        />
      );
    }
  }
  return stars;
};


export const StarRating = ({ rating, maxRating = 5 }) => {
  const numericRating = Math.min(Math.max(Number(rating) || 0, 0), maxRating);
  const stars = Array.from({ length: maxRating }, (_, index) => {
    const difference = numericRating - index;
    if (difference >= 1) {
      return { type: 'full' };
    } else if (difference > 0) {
      return { type: 'half', percentage: difference * 100 };
    } else {
      return { type: 'empty' };
    }
  });
  return (
    <div className="star-rating" style={{ display: 'flex', gap: '1px' }}>
      {stars.map((star, index) => (
        <div key={index} style={{ position: 'relative', width: '20px', height: '20px' }}>
          {star.type === 'full' ? (
            <FullStar />
          ) : star.type === 'half' ? (
            <HalfStar star={star} />
          ) : (
            <EmptyStar />
          )}
        </div>
      ))}
    </div>
  );
};

const loginModelOpen = () => {
  const modal = new window.bootstrap.Modal(document.getElementById("loginModal"));
  modal.show();
}

export const loginModelClose = () => {
  const modalElement = document.getElementById("loginModal");
  if (modalElement) {
    const modalInstance = window.bootstrap.Modal.getInstance(modalElement) || new window.bootstrap.Modal(modalElement);
    modalInstance.hide();
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }
}

export { ErrorMessage, SuccessMessage, removeAuth, Apiloader, loginModelOpen,getEstimatedDelivery };
